import Vue from 'vue'
import expressApi from '../apis/express'

const state = {
  orders: {
    total: 0,
    sendCount: 0,
    receiveCount: 0,
    send: {
      currentPage: 0,
      lastPage: 1,
      data: [],
      total: 0,
      loading: false
    },
    receive: {
      currentPage: 0,
      lastPage: 1,
      data: [],
      total: 0,
      loading: false
    }
  },
  order: {

  }
}

const actions = {
  postPackage ({ commit }, { data }) {
    return expressApi.postPackage(data)
      .then((res) => {
        commit('addExpressOrder', res.data)
        return res.data
      })
  },
  updatePackage ({ commit }, { data }) {
    return expressApi.putPackage(data)
      .then((res) => {
        commit('updateExpressOrder', res.data)
        return res.data
      })
  },
  getOrderInfo ({ commit, state }, id) {
    return expressApi.getExpressInfo(id)
      .then((res) => {
        commit('setOrderDetail', res.data)
        return res.data
      })
  },
  getExpressOrders ({ commit }, { type, page, perPage }) {
    commit('setExpressOrdersLoading', { type, loading: true })
    return expressApi.getExpressOrders(type, page, perPage)
      .then((res) => {
        commit('setExpressOrders', { type, data: res.data })
        return res.data
      })
  },
  getExpressOrderCount ({ commit }) {
    return expressApi.getOrderCount()
      .then(res => {
        commit('setOrderCount', res.data)
      })
  },
  cancelExpress ({ commit }, id) {
    return expressApi.cancelExpress(id)
      .then((res) => {
        commit('updateExpressOrder', res.data)
        return res.data
      })
  }
}

const mutations = {
  setExpressOrdersLoading (state, { type, loading }) {
    Vue.set(state.orders, type, {
      ...state.orders[type],
      loading
    })
  },
  setExpressOrders (state, { type, data }) {
    Vue.set(state.orders, type, {
      ...state.orders[type],
      data: data.current_page === 1 ? data.data : state.orders[type].data.concat(data.data),
      loading: false,
      currentPage: data.current_page,
      lastPage: data.last_page,
      total: data.total
    })
  },
  setOrderDetail (state, data) {
    state.order = data
  },
  setOrderCount (state, data) {
    state.orders.total = data.total
    state.orders.sendCount = data.send_count
    state.orders.receiveCount = data.receive_count
  },
  addExpressOrder (state, data) {
    state.orders.total += 1
    state.orders.sendCount += 1

    if (state.orders.send.total !== 0) {
      state.orders.send.data.unshift(data)
      state.orders.send.total += 1
    }
  },
  updateExpressOrder (state, data) {
    if (data.id === state.order.id) {
      state.order = {
        ...state.order,
        ...data
      }
    }

    for (let i = 0; i < state.orders.send.data.length; ++i) {
      if (state.orders.send.data[i].id === data.id) {
        Vue.set(state.orders.send.data, i, {
          ...state.orders.send.data[i],
          ...data
        })
      }
    }

    for (let i = 0; i < state.orders.receive.data.length; ++i) {
      if (state.orders.receive.data[i].id === data.id) {
        Vue.set(state.orders.receive.data, i, {
          ...state.orders.receive.data[i],
          ...data
        })
      }
    }
  }
}

export default {
  state,
  actions,
  mutations
}
